import { gsap, ScrollTrigger } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

function gallerySection() {
    var gallerySwiper = new Swiper(".gallery__swiper", {
        modules: [ Autoplay ],
        slidesPerView: 1.6,
        spaceBetween: 7,
        loop: true,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            1025: {
                slidesPerView: 3.5,
                spaceBetween: 30,
            },
        },
    });
}

function jobOpenSection() {
    // location placement on responsive
    const jobItem = document.querySelectorAll('.job-open__item');
    jobItem.forEach(el => {
        const jobLocationFile = el.querySelector('.job-open__location-file');
        const jobDescriptionWrapper = el.querySelector('.job-open__description-wrapper');
        const jobLocation = el.querySelector('.job-open__location');
        
        if (window.innerWidth < 1200) {
            jobDescriptionWrapper.prepend(jobLocation);
        } else {
            jobLocationFile.prepend(jobLocation);
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    gallerySection();
    jobOpenSection();
})

window.addEventListener('resize', () => {
    jobOpenSection();
})